<template>
  <DefaultLayout
    menuIndex="/factory"
    openeds="attribution"
  >

    <div class="page-header">
      <div>
        <el-select
          v-model="preselect.name"
          clearable
          placeholder="请选择公司"
          @change="preselectChange"
          @clear="this.tableData = []"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div>
        <el-button
          type="primary"
          @click="dialogFormVisible = true"
        >
          <el-icon>
            <Plus />
          </el-icon>
        </el-button>
      </div>
    </div>

    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="新增厂区"
      width="500px"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
      >
        <el-form-item
          label="厂区名称"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            v-model="form.name"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="所属公司"
          :label-width="formLabelWidth"
          prop="company"
        >
          <el-select
            v-model="form.company"
            clearable
            placeholder="请选择公司"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="formCancel('form')">重置</el-button>
          <el-button
            type="primary"
            @click="formSubmit('form')"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>

    <div style="padding: 20px;">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column
          type="index"
          label="#"
          width="50"
          :resizable="false"
        />
        <el-table-column
          prop="name"
          label="厂区名称"
          width="200"
          :resizable="false"
        />
        <el-table-column
          prop="company"
          label="所属公司"
          :resizable="false"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="120"
          :resizable="false"
        >
          <template #default="scope">
            <el-button
              @click="openDelete(scope)"
              type="danger"
            >
              <el-icon>
                <Delete />
              </el-icon>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </DefaultLayout>
</template>

<script>
import DefaultLayout from '../components/layout/DefaultLayout.vue'
import { Companies, Factories } from '../api/request.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { WarningFilled } from '@element-plus/icons-vue';
import { markRaw } from 'vue';

export default {
  name: 'FactoryPage',
  components: {
    DefaultLayout
  },
  methods: {
    getCompanyAccountInformation () {
      Companies.GetCompanyAccountInformation().then(res => {
        // console.log(res);
        let optionsTem = [];
        let companyKeyValueTem = {};
        for (let i = 0, len = res.length; i < len; i++) {
          optionsTem.push({
            value: res[i].id,
            label: res[i].name
          });
          companyKeyValueTem[res[i].id] = res[i].name;
        }
        this.options = optionsTem;
        this.companyKeyValue = companyKeyValueTem;
      })
    },
    getFactories (companyId) {
      Factories.GetFactories(companyId).then(res => {
        // console.log(res);
        let tableDataTem = [];
        for (let i = 0, len = res.length; i < len; i++) {
          tableDataTem.push({
            name: res[i].name,
            company: this.companyKeyValue[res[i].companyId],
            factoryId: res[i].id,
            companyId: res[i].companyId,
          });
        }
        this.tableData = tableDataTem;
      })
    },
    formCancel (formName) {
      this.$refs[formName].resetFields();
    },
    formSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Factories.AddFactories(
            this.form.name,
            this.form.company,
          ).then(() => {
            // console.log(res);
            ElMessage({
              showClose: true,
              message: '添加厂区成功',
              type: 'success',
            })
            if (this.preselect.name === this.form.company) {
              this.preselectChange(this.preselect.name);
            }
            this.dialogFormVisible = false;
            this.$refs[formName].resetFields();
          })
        }
      })
    },
    openDelete (data) {
      // console.log(data.row);
      ElMessageBox.confirm(
        `<strong style="color: #F56C6C;">确定删除 ${data.row.name} 的信息?</strong>`,
        {
          type: 'error',
          showCancelButton: false,
          autofocus: false,
          confirmButtonClass: 'factoryPage-delete-confirmButtonClass',
          dangerouslyUseHTMLString: true,
          icon: markRaw(WarningFilled),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }
      ).then(() => {
        Factories.DeleteFactories(data.row.factoryId).then((res) => {
          if (res === 'success') {
            ElMessage({
              showClose: true,
              type: 'success',
              message: '删除成功',
            })
            this.getFactories(data.row.companyId);
          } else {
            ElMessage({
              showClose: true,
              type: 'error',
              message: '网络错误',
            })
          }
        })
      })
        .catch(() => {
          ElMessage({
            showClose: true,
            type: 'info',
            message: '取消删除',
          })
        })
    },
    preselectChange (val) {
      if (val !== '') {
        this.getFactories(val);
      }
    }
  },
  data () {
    return {
      dialogFormVisible: false,
      formLabelWidth: '80px',
      form: {
        name: '',
        company: '',
      },
      tableData: [
        // {
        //     name: '厂区名称',
        //     company: '公司名称',
        //     factoryId: '1',
        //     companyId: '1'
        // },
      ],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        company: [
          { required: true, message: '请选择公司', trigger: 'blur' },
        ],
      },
      options: [
        // {
        //     value: 'companyId',
        //     label: '公司名称',
        // },
      ],
      preselect: {
        name: '',
      },
      companyKeyValue: {},
    }
  },
  created () {
    this.getCompanyAccountInformation();
  }
}
</script>

<style>
.factoryPage-delete-confirmButtonClass {
  background: #F56C6C !important;
  border: 0;
}
</style>

<style scoped>
.page-header {
  background-color: #F9F9F9;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input,
.el-date-editor.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
